/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { VersionDto } from './version.dto';
import { VersionMapper } from './version.mapper';

@Injectable()
export class VersionRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(): Observable<VersionDto> {
    return this.httpGet(`${this.bp}/version`, VersionMapper);
  }
}
